<ng-container *ngLet="items$ | async as items">
    <ng-container *ngFor="let item of items">
        <mat-icon *ngIf="item.type === 'Breadcrumb'"
                  class="title-arrow">keyboard_arrow_right</mat-icon>

        <span class="nav-title">
            <a *ngLet="item.translationKey | translate as linkText"
               [routerLink]="item.isMatch(currentLink) ? [currentLink] : [item.cleanRouterLink]"
               [class.single]="items.length === 1"
               [class.active]="isActive(item) | async"
               [queryParamsHandling]="item.isMatch(currentLink) ? 'preserve' : ''">
                <span [matTooltip]="linkText"
                      class="nav-link-text">{{ (item.customTitle$ | async) || linkText }}</span>
            </a>
        </span>
    </ng-container>
</ng-container>

<ng-container *ngIf="headerOverride.template$ | async as headerTemplate">
    <ng-container *ngTemplateOutlet="headerTemplate">
    </ng-container>
</ng-container>

<div #pageAriaTitle
     *ngLet="activePage$ | async as activePage"
     class="cdk-visually-hidden"
     tabindex="-1">
    {{
            'a11y_page_title' | translate: {
                                    title: activePage.translationKey ?
                                        (activePage.translationKey | translate) :
                                        activePage.title
                                }
    }}
</div>
